import React, { Component } from 'react';


class ViewQuantity extends Component {
    render() {
         const { data } = this.props;

        return (
            <div className="table-responsive">
                <table className="table">
                    <thead>
                        <tr>
                            <th width="60%"></th>
                            <th width="40%">Quantity</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td><b>Total</b></td>
                            <td><b>{data?.total}</b></td>
                        </tr>
                        <tr className="cursor-pointer">
                            <td onClick={() => this.props.clickHandler(1)}><u>Seedworks Sale</u></td>
                            <td><b>{data?.total_seedworks}</b></td>
                        </tr>
                        <tr className="cursor-pointer">
                            <td onClick={() => this.props.clickHandler(2)}><u>Competitor Sale</u></td>
                            <td><b>{data?.total_competitor}</b></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        )
    }
}

export default ViewQuantity;
